import { render, staticRenderFns } from "./Manage-Category.vue?vue&type=template&id=35b0cb7e&"
import script from "./Manage-Category.vue?vue&type=script&lang=js&"
export * from "./Manage-Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports